import React, { FC, useMemo } from 'react';
import { DatePickerProps } from 'antd/lib/date-picker';
import dayjs from 'dayjs';
import { DatePicker as LibDatePicker } from '@custis/common';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

type Props = DatePickerProps;

export const DatePicker: FC<Props> = (props) => {
  const date = useMemo(() => {
    if (!props.value) {
      return null;
    }

    return dayjs.isDayjs(props.value)
      ? props.value.startOf('day').utc(true)
      : dayjs(props.value).startOf('day').utc(true);
  }, [props.value]);

  return <LibDatePicker {...props} showNow={false} value={date} />;
};
